module.exports = __webpack_public_path__ + "img/enote.8b099bab.svg";